import React from 'react';

import { Text as AchievableText } from '@achievable-me/ux';

const Text = (props) => {
  const {
    children,
    className,
    inline,
    italic,
    size,
    theme,
    underline,
    uppercase,
    weight,
  } = props;

  return (
    <AchievableText
      className={className}
      inline={inline}
      italic={italic}
      size={size}
      theme={theme}
      underline={underline}
      uppercase={uppercase}
      weight={weight}
    >
      {children}
    </AchievableText>
  );
};

export default Text;
